import { createFileRoute } from '@tanstack/react-router';
import { NewApplicationPage } from '../../features/merchant-onboarding/NewApplicationPage.jsx';

export const Route = createFileRoute('/_app/merchants/onboarding/new')({ component: NewApplicationPage });
